import React from "react";
import ApiCard from "../components/ApiCard";
export default function BridgeTest() {
    return (
        <ApiCard
            title="Bridge Registration"
            description="Register / Update ABDM Bridge"
            url="abdm/update-bridge/"
            method="PATCH"
            buttonText="Update Bridge"
            payload={{
                url: window.location.origin
            }}
            onSuccess={(data) => {
                console.log("Bridge Updated", data);
            }}
        />
    );
}